import React, { FC } from 'react';
import { scaleOP } from '@components/frame';
import { fontOP } from '@styles/fonts';
import { useRoute } from '@react-navigation/native';
import { OP_DOCUMENTS_DISPLAY_MODE, scheduledProductionOperationIdParam } from '@components/operatorPanel/constants/operatorPanel.constants';
import { KEYS_TAGS, TAG_KEYS } from '@components/imageHandling/common';
import OperatorPanelInformationDocumentsDifferentModes from '@components/operatorPanel/components/OperatorPanelInformation/components/OperatorPanelInformationDocuments/OperatorPanelInformationDocumentsDifferentModes';
import { useSelector } from 'react-redux';
import i18n from 'i18n-js';
import {
  selectCurrentContextImagesDocuments,
  selectCurrentContextLoading,
} from '../../../../../../reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface OperatorPanelInformationAllDocumentsScreenProps {}

const OperatorPanelInformationAllDocumentsScreen: FC<OperatorPanelInformationAllDocumentsScreenProps> = () => {
  const route = useRoute();

  const imagesDocuments = useSelector(selectCurrentContextImagesDocuments);
  const imagesDocumentsLoading = useSelector(selectCurrentContextLoading);

  const selectedJobId = route.params?.[scheduledProductionOperationIdParam];
  const isMachinePerspective = selectedJobId == null;

  const selectedImageKey = route?.params?.selectedImageKey;

  const selectedImage = imagesDocuments?.find((i) => i.contentHash === selectedImageKey);

  const noResult = imagesDocuments?.length === 0 && !imagesDocumentsLoading;
  const isTileMode = route.params?.mode === OP_DOCUMENTS_DISPLAY_MODE.TILE;
  const title = !isTileMode && selectedImage ? selectedImage?.title : i18n.t('All Documents');

  return (
    <OperatorPanelInformationDocumentsDifferentModes
      {...{
        images: imagesDocuments,
        noResult,
        title,
        font: fontOP,
        scale: scaleOP,
        withAttachToBlock: true,
        scopeIdsForDefaultLinking: [
          isMachinePerspective ? (KEYS_TAGS.ProductionBatch as keyof typeof TAG_KEYS) : (KEYS_TAGS.ProductionOperation as keyof typeof TAG_KEYS),
        ],
        testID: TEST_IDS.operatorPanel.information.allDocuments.root,
      }}
    />
  );
};

export default OperatorPanelInformationAllDocumentsScreen;
